import React, { useState, useEffect } from 'react';
import axios from 'axios';
import swal from 'sweetalert';
import { Link } from 'react-router-dom';
import {
    Row,
    Col,

} from "reactstrap";
import { urlApi } from "../../../../../config";

const BannerList = () => {
    const [loading, setLoading] = useState(true);
    const [bannerlist, setBannerlist] = useState([]);
    const [disabled, setDisabled] = useState(false);

    useEffect(() => {
        axios.get(`/api/view-banner`).then(res => {
            //console.log(res.data.category);
            if(res.status === 200)
            {
               setBannerlist(res.data.banner)
            }
           setLoading(false);

        });
    }, []);

    const deleteBanner = (e, id) => {

        e.preventDefault();
        const thisClicked = e.currentTarget;

        axios.delete(`/api/delete-banner/${id}`).then(res => {
            if(res.data.status === 200)
            {
               swal("Banner Eliminado","","success");
               thisClicked.closest("tr").remove();
            }else if (res.data.status === 404) {
                swal("Banner Eliminado",res.data.message,"error");
            }

        });

    }
    var viewbanner_HTMLTABLE = "";
    if (loading) {

        return <h4>Loading Banners</h4>
        
    }else{
        viewbanner_HTMLTABLE =
        bannerlist.map( (item) => {
            return(
                <tr key={item.id}>
                    
                    <td>{item.name}</td>

                    <td><img src={`https://lordon.com.mx:81/${item.image}`} width="50px" alt={item.name}/></td>

                    <td>
                    <Link to={`/updatebanner/${item.id}`} target="_blank">
                  <a>
                    <i className="fa fa-pencil btn-solid btn-xs" aria-hidden="true"></i>
                  </a>
                </Link>
                    </td>
                 {bannerlist.length === 1 ? <td>
                        <button type="button" disabled={disabled} onClick={() => setDisabled(true)} className="fa fa-trash btn-solid btn-xs"></button>
                    </td>:<td>
                        <button type="button" onClick={ (e) => deleteBanner(e, item.id) } className="fa fa-trash btn-solid btn-xs"></button>
                    </td>}
                </tr>
            )
        });
    }

    return (
        <Row>
            <Col sm="12">
                <table className="table mb-0 table-responsive-sm">
                    <thead>
                        <tr>
                            <th scope="col">Nombre Banner</th>
                            <th scope="col">Imagen Banner</th>
                        </tr>
                    </thead>
                  <tbody>
                      {viewbanner_HTMLTABLE}
                  </tbody>
                </table>
            </Col>
        </Row>
    )

}

export default BannerList;